export default "__VITE_ASSET__Dh6hrgz7__"